// SuggestedUserListShimmer.tsx

import Shimmer from "./Shimmer";


const SuggestedUserListShimmer = () => {
  return (
    <div className="divide-y divide-primary-subtle rounded-lg border border-primary-subtle overflow-hidden">
      {Array.from({ length: 3 }).map((_, index) => (
        <div
          key={index}
          className="flex items-center justify-between px-4 py-3"
        >
          {/* Left Side */}
          <div className="flex items-center gap-3">
            <Shimmer className="w-10 h-10 rounded-full" />

            <div className="space-y-2">
              <Shimmer className="h-4 w-28" />
              <Shimmer className="h-5 w-24 rounded-full" />
            </div>
          </div>

          {/* Right Side Button */}
          <Shimmer className="h-8 w-16 rounded-lg" />
        </div>
      ))}
    </div>
  );
};

export default SuggestedUserListShimmer;